import { Drawer } from '@usealloy/component-library';
import styled from 'styled-components';
import { COMPLEX_ISLAND_VERTICAL_MARGIN } from './constants';

export const StyledIslandDrawer = styled(Drawer) <{ canvasHeight: number }>`
  /* some wrappers might change the cursor, so we set it again here to guarantee it's always the default one */
  cursor: default;
  &&& {
    /* width is specified as a Drawer prop */
    height: fit-content;
    max-height: ${p => p.canvasHeight - (2 * COMPLEX_ISLAND_VERTICAL_MARGIN)}px;
    top: ${COMPLEX_ISLAND_VERTICAL_MARGIN}px;
    border-radius: var(--cl-radius-4) 0px 0px var(--cl-radius-4);
  }

  /* targets the Drawer title container */
  & > div:first-child  {
    border-radius: var(--cl-radius-4) 0px 0px 0px;
  }

  /* targets the "X" button on the drawer to remove a problematic width:100% on it */
  & > div:first-child div:nth-child(2) {
    width: auto;
  }
`;


export const StyledIslandDrawerContent = styled.div``;

export const StyledIslandItemContainer = styled.div`
  &&& {
    display: flex;
    flex-direction: column;
    gap: var(--cl-space-3);
    padding: var(--cl-space-4);
    overflow-y: scroll;
  }
`;
